import { PlanFamily } from './generated';
import rawData from './plans.json';

type SupportedPlanFamilies =
  | PlanFamily.FREEMIUM_PLANS
  | PlanFamily.BASE_PLANS
  | PlanFamily.ULTIMATE_PLANS
  | PlanFamily.ENTERPRISE_PLANS;

export const FEATURE_PER_FAMILY = rawData as unknown as Record<SupportedPlanFamilies, string[]>;
